export default "__VITE_ASSET__Dg_Jlv$a__"